import { render, staticRenderFns } from "./goodsGroupDetail.vue?vue&type=template&id=6204bdb4&scoped=true&"
import script from "./goodsGroupDetail.vue?vue&type=script&lang=js&"
export * from "./goodsGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsGroupDetail.vue?vue&type=style&index=0&id=6204bdb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204bdb4",
  null
  
)

component.options.__file = "goodsGroupDetail.vue"
export default component.exports